import {combineReducers} from 'redux'
import game from './game'

const app = combineReducers({
    game
});

export default app



// WEBPACK FOOTER //
// ./src/reducers/index.js